import {INavLink} from "modules/types/routing";

export const helpPagesLinks: INavLink[] = [
	// {
	// 	title: "help.how_to",
	// 	href: "/help/guidelines",
	// },
	{
		title: "help.faqs",
		href: "/help/faq",
	},
	{
		title: "help.contact_us",
		href: "/help/contact",
	},
	{
		title: "help.terms",
		href: "/help/terms",
	},
];
